import React from "react";
import BuyMembership from "../../Common/StripeForms/BuyMembership/BuyMembership";

const Payment = ({ handleNext, value }: any) => {
  return (
    <div>
      <div className="step-innercontent step5 payment-step5">
        <div className="consult-section-heading text-center">
          <h3 className="my-5 p-0">Payment</h3>
        </div>
        <div className="mt-3 mb-5">
          <BuyMembership membershipData={value} />
        </div>
      </div>
    </div>
  );
};

export default Payment;
